module.exports = __webpack_public_path__ + "img/51626516_L.a1dff219.png";